import { Component, OnInit } from '@angular/core';
import { AuthSession } from '@navify-platform/auth';
import { NavifyService } from 'src/app/auth/services/navify.service';
import { LabelService } from 'src/app/shared/services/label.service';
import { EnclaveService } from 'src/app/shared/services/enclave.service';
import { finalize } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-app-lobby',
  templateUrl: './app-lobby.component.html',
  styleUrls: ['./app-lobby.component.scss']
})
export class AppLobbyComponent  implements OnInit{
  i18n = this.labelService.labels;
  sessionInfo!: AuthSession;
  isDownloading: boolean = false;
  links: string[] = [
  ]

  constructor(
    private readonly nanvifyService: NavifyService,
    private readonly labelService: LabelService,
    private readonly service: EnclaveService

  ) { }

  ngOnInit() {
    this.sessionInfo = this.nanvifyService.sessionInfo
  }

  downloadDocumentation(): void {
    if (this.isDownloading) { return; }
    this.isDownloading = true;
    this.service.getUserManualDetails().pipe(
      finalize(() => (this.isDownloading = false))
    ).subscribe({
      next: (response) => {
        if (response?.result?.length > 0) {
          globalThis.open(response.result[0], '_blank');
        }
      },
      error: (error) => {
      }
    });
  }

}
